let envConfig = {};

export const setConfig = (config) => {
  envConfig = config || {};
};

// optional — shortcut proxy for easier access
export const Config = new Proxy(
  {},
  {
    get(_, key) {
      return envConfig[key] || process.env[key] || null;
    },
  }
);
